import { Colors } from '@oy/uicore';
import { IconButton, Portal, Text } from '@oy/uidesktop';
import classNames from 'classnames';
import { ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PATH } from 'src/constants/Path';
import { useEnv, useTranslate } from 'src/hooks';
import styles from './FullpageLayout.module.css';

const FullpageLayout = ({
  title,
  children,
  rightChild,
  ...props
}: {
  title?: ReactNode;
  children: ReactNode;
  rightChild?: ReactNode;
} & React.HTMLAttributes<HTMLDivElement>) => {
  const navigate = useNavigate();
  const location = useLocation();

  const closePage = () => {
    if (
      location.key === 'default' ||
      location.pathname.includes(PATH.ACCOUNTS.userProfile)
    ) {
      navigate(PATH.SETTINGS.path);
      return;
    }
    navigate(-1);
  };
  const { isProdEnv } = useEnv();
  const { getTranslation } = useTranslate();

  return (
    <Portal rootId="root">
      <div className={styles.container}>
        {!isProdEnv && (
          <div className={classNames(styles.banner, styles.staging)}>
            <Text textStyle={Text.Style.BodyMdRegular} color={Colors.WHITE}>
              {getTranslation('mainLayout_banner_demoMode')}
            </Text>
          </div>
        )}
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <IconButton
              onClick={closePage}
              iconName="close"
              color={IconButton.Color.Secondary}
            />
            <div className={styles.divider} />
            <Text textStyle={Text.Style.HeadingSm}>{title}</Text>
          </div>
          {rightChild}
        </div>
        <div className={classNames(styles.content, props.className)} {...props}>
          {children}
        </div>
      </div>
    </Portal>
  );
};

export default FullpageLayout;
